import { type Component, createEffect } from 'solid-js'
import { createStore } from 'solid-js/store'
import Button from '~/components/Button'
import Form from '~/components/Form'
import Input from '~/components/Input'
import Modal from '~/components/Modal'
import TagInput from '~/components/TagInput'

export interface AttributeModalPropsType {
  isOpen: boolean
  onClose: () => void
  attribute: { name: string; values: string[] } | null
  onSave: (attribute: { name: string; values: string[] }) => void
}

/** Alta y edición de un atributo (talla, color…). Mismo patrón que `FichaModal`. */
const AttributeModal: Component<AttributeModalPropsType> = props => {
  const [draft, setDraft] = createStore<{ name: string; values: string[] }>({ name: '', values: [] })

  createEffect(() => {
    if (!props.isOpen) return
    const attr = props.attribute
    setDraft(attr ? { name: attr.name, values: [...(attr.values ?? [])] } : { name: '', values: [] })
  })

  const isValid = () => draft.name.trim().length > 0 && draft.values.length > 0

  const handleSave = () => {
    if (!isValid()) return
    props.onSave({ name: draft.name.trim(), values: draft.values })
  }

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} size="sm" closable>
      <Modal.Header>
        <h2 class="text-lg font-bold text-foreground">{props.attribute ? 'Editar atributo' : 'Nuevo atributo'}</h2>
      </Modal.Header>
      <Modal.Body>
        <Form id="attribute-form" onSubmit={handleSave}>
          <div class="space-y-4">
            <Input label="Nombre" value={draft.name} onInput={e => setDraft('name', e.currentTarget.value)} placeholder="Talla" required />
            <div>
              <TagInput label="Valores" tags={draft.values} onTagsChange={values => setDraft('values', values)} placeholder="40, 41, 42… y Enter" />
              <p class="text-xs text-foreground-subtle mt-1.5">Cada valor genera una variante al combinar con los demás atributos.</p>
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div class="flex justify-end gap-2">
          <Button variant="soft" color="default" onClick={props.onClose}>
            Cancelar
          </Button>
          <Button type="submit" form="attribute-form" disabled={!isValid()}>
            {props.attribute ? 'Guardar' : 'Añadir'}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default AttributeModal
